import ViewBase from '../../view-base.view';
import aiJpoModel from '../../../models/schedule/ai-jpo.model';
import languageModel from '../../../models/language.model';
import paginationComponent from '../../../components/pagination/pagination.component';

export default function ShopReportTabView() {
    ViewBase.call(this);

    let reportData = [];
    let totalCount = 0;
    let totalAssigned = 0;
    let totalUnassigned = 0;
    let pageIndex = 1;
    let pageSize = 25;
    let filter = {};
    let statusFilter = '';

    let loadReport = () => {
        this.showLoading();

        let req = {
            countryCode: filter.countryCode,
            bu: filter.bu,
            month: filter.month,
            page: pageIndex,
            pageSize: pageSize
        };
        if (statusFilter) req.status = statusFilter;

        aiJpoModel.getShopProcessingReport(req)
            .then((result) => {
                reportData = result.items || [];
                totalCount = result.total || 0;
                totalAssigned = result.totalAssigned ?? reportData.filter(r => r.status === 'Assigned').length;
                totalUnassigned = result.totalUnassigned ?? reportData.filter(r => r.status === 'Unassigned').length;
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading();
            });
    };

    let onPageChanged = (p) => {
        pageIndex = p;
        loadReport();
    };

    let onPageSizeChanged = (p, ps) => {
        pageIndex = p;
        pageSize = ps;
        loadReport();
    };

    return {
        oninit: ({ attrs }) => {
            filter = attrs.filter;
            loadReport();
        },
        onupdate: ({ attrs }) => {
            if (attrs.searchVersion !== filter._searchVersion) {
                filter = attrs.filter;
                filter._searchVersion = attrs.searchVersion;
                pageIndex = 1;
                loadReport();
            }
        },
        view: () => {
            return [
                // Status filter
                m('.card.mb-3',
                    m('.card-body',
                        m('.row.g-4',
                            m('.col-sm-6.col-lg-3',
                                m('label.form-label', languageModel.getText('', 'Status')),
                                m('select.form-control.form-control-bg', {
                                    value: statusFilter,
                                    onchange: (e) => { statusFilter = e.target.value; pageIndex = 1; loadReport(); }
                                }, [
                                    m('option', { value: '' }, languageModel.getText('', 'ALL')),
                                    m('option', { value: 'Assigned' }, languageModel.getText('', 'Assigned')),
                                    m('option', { value: 'Unassigned' }, languageModel.getText('', 'Unassigned')),
                                ])
                            )
                        )
                    )
                ),

                // Stats bar
                totalCount > 0 && m('.card.mb-3',
                    m('.card-body',
                        m('.d-flex.justify-content-center.gap-4',
                            m('.ai-jpo-stat-item', [
                                m('.ai-jpo-stat-value', totalCount.toLocaleString()),
                                m('.ai-jpo-stat-label', languageModel.getText('', 'Total Shops'))
                            ]),
                            m('.ai-jpo-stat-item', [
                                m('.ai-jpo-stat-value.ai-jpo-stat-success', totalAssigned.toLocaleString()),
                                m('.ai-jpo-stat-label', languageModel.getText('', 'Assigned'))
                            ]),
                            m('.ai-jpo-stat-item', [
                                m('.ai-jpo-stat-value' + (totalUnassigned > 0 ? '.ai-jpo-stat-danger' : ''), totalUnassigned.toLocaleString()),
                                m('.ai-jpo-stat-label', languageModel.getText('', 'Unassigned'))
                            ])
                        )
                    )
                ),

                // Report table
                m('.card',
                    m('.card-body',
                        m('.table-responsive',
                            m('table.table.table-bordered',
                                m('thead.thead-bggrey',
                                    m('tr.align-middle', [
                                        m('th', { scope: 'col', style: 'width: 50px;' }, '#'),
                                        m('th', { scope: 'col' }, languageModel.getText('', 'Store Code')),
                                        m('th', { scope: 'col', style: 'width: 130px;' }, languageModel.getText('', 'Latitude')),
                                        m('th', { scope: 'col', style: 'width: 130px;' }, languageModel.getText('', 'Longitude')),
                                        m('th', { scope: 'col', style: 'width: 80px;' }, languageModel.getText('', 'Grade')),
                                        m('th', { scope: 'col', style: 'width: 110px;' }, languageModel.getText('', 'Status')),
                                        m('th', { scope: 'col' }, languageModel.getText('', 'Zone')),
                                        m('th', { scope: 'col' }, languageModel.getText('', 'Remarks')),
                                        m('th', { scope: 'col', style: 'width: 130px;' }, languageModel.getText('', 'Process Date')),
                                    ])
                                ),
                                m('tbody',
                                    reportData.length === 0 &&
                                        m('tr.align-middle',
                                            m('td', { colspan: '9' }, languageModel.getText('', 'No records found.'))
                                        ),
                                    reportData.map((r, i) => {
                                        const offset = (pageIndex - 1) * pageSize;
                                        const isAssigned = r.status === 'Assigned';
                                        return m('tr', [
                                            m('td.text-muted', offset + i + 1),
                                            m('td', m('strong', r.storeCode || '')),
                                            m('td.text-end', r.latitude != null ? Number(r.latitude).toFixed(6) : ''),
                                            m('td.text-end', r.longitude != null ? Number(r.longitude).toFixed(6) : ''),
                                            m('td.text-center',
                                                m('span.ai-jpo-grade.ai-jpo-grade-' + (r.grade || '').toLowerCase(), r.grade || '')
                                            ),
                                            m('td.text-center',
                                                m('span.ai-jpo-status-badge' + (isAssigned ? '.ai-jpo-status-assigned' : '.ai-jpo-status-unassigned'),
                                                    r.status || '')
                                            ),
                                            m('td', r.zoneName || ''),
                                            m('td', { style: 'font-size: 12px; color: #666;' }, r.remarks || ''),
                                            m('td', { style: 'font-size: 12px; color: #999;' }, r.processDate || ''),
                                        ]);
                                    })
                                )
                            )
                        ),
                        !this._isLoading &&
                            m('.px-3.pt-2',
                                m(paginationComponent, {
                                    currentPage: pageIndex,
                                    pageSize: pageSize,
                                    totalItems: totalCount,
                                    onPageChanged: onPageChanged,
                                    onPageSizeChanged: onPageSizeChanged
                                })
                            )
                    )
                )
            ];
        }
    };
}
